<div
  class="d-flex justify-content-stretch"
  [ngClass]="buttonPosition === 'start' ? 'flex-row' : 'flex-row-reverse'">
  <button
    type="button"
    class="ca-btn ca-btn-neutral pt-1 pb-1"
    [ngClass]="buttonPosition === 'start' ? 'me-1' : 'ms-1'"
    (click)="onOpen($event)">
    <i class="fa-solid fa-xl fa-address-book"></i>
  </button>
  <ca-user-dropdown-selector
    class="flex-grow-1 flex-shrink-1"
    style="overflow-x: hidden"
    [userType]="userType"
    [multiple]="true"
    [closeOnSelect]="false"
    [placeholder]="(placeholder | abpLocalization) + '...'"
    [itemsPerPage]="itemsPerPage"
    [addClassToDropdown]="addClassToDropdown"
    [enabledUserStatusFilter]="enabledUserStatusFilter"
    [dropdownPosition]="dropdownPosition"
    (ngModelChange)="onDropdownSelectorChange($event)"
    [(ngModel)]="value"></ca-user-dropdown-selector>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      <span>{{ 'AbpUi::UserPopupSelector:Title' | abpLocalization }}</span>
    </h4>
  </div>
  <div class="modal-body pt-0 d-flex justify-content-stretch align-items-stretch">
    <div class="modal-wrapper flex-grow-1 flex-shrink-1">
      <div class="department-list-wrapper">
        <div class="department-list-header p-2 fw-bold">
          <span>{{ 'AbpUi::UserPopupSelector:Departments' | abpLocalization }}</span>
        </div>
        <div class="p-2 search-box-wrapper">
          <input
            type="text"
            class="form-control form-control-sm"
            [placeholder]="('AbpUi::DoSearch' | abpLocalization) + '...'"
            (keyup)="onDepartmentSearchInputChange($event)"
            (keyup.enter)="onDepartmentSearchInputEnter($event)" />
          <i class="fas fa-search"></i>
        </div>
        <div class="department-list">
          <ca-department-tree-v2
            (selectionChange)="onDepartmentSelectionChange($event)"
            [quickSearchTerm]="departmentSearchKeyword"></ca-department-tree-v2>
        </div>
      </div>
      <div class="user-list-wrapper">
        <div class="user-list-header p-2 fw-bold">
          <span>{{ 'AbpUi::UserPopupSelector:Users' | abpLocalization }}</span>
        </div>
        <div class="row m-0 search-box-wrapper">
          <div class="col p-2">
            <input
              type="text"
              class="form-control form-control-sm"
              [placeholder]="('AbpUi::DoSearch' | abpLocalization) + '...'"
              (keyup)="onUserSearchInputChange($event)"
              (keyup.enter)="onUserSearchInputEnter($event)" />
            <i class="fas fa-search"></i>
          </div>
          @if (enabledUserStatusFilter) {
            <div class="col-2 p-2">
              <ng-select
                #selector
                [clearable]="false"
                [searchable]="false"
                [items]="statusItems"
                [ngModel]="currentStatus"
                [ngbTooltip]="currentStatus"
                [disableTooltip]="disableTooltip"
                (open)="disableTooltip = true"
                (close)="disableTooltip = false"
                (open)="openStatusSelector($event)"
                (change)="changeStatusFilter($event)">
                <ng-template ng-label-tmp let-item="item">
                  <div placement="top" [ngClass]="item.class"></div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  <div class="d-flex flex-row align-items-center">
                    <span [ngClass]="item.class"></span>
                    <span class="ms-2">{{ item.label }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          }
        </div>

        <div class="user-list">
          <ca-user-list-selector
            [departmentId]="departmentId"
            [departmentBased]="true"
            [quickSearchTerm]="userSearchKeyword"
            [userType]="userType"
            [status]="status"
            [(ngModel)]="selectedUsers"></ca-user-list-selector>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      *ngIf="selectedUsers.length > 0"
      class="btn ca-btn ca-btn-neutral"
      type="button"
      (click)="onClickClear()">
      <span class="with-no-icon">
        {{ 'AbpUi::Clear' | abpLocalization }}
        <span class="text-muted selected-user-count-label">{{ selectedUsers.length }}</span>
      </span>
    </button>
    <mat-divider *ngIf="selectedUsers.length > 0" class="ms-1 me-1" [vertical]="true"></mat-divider>
    <button class="btn ca-btn ca-btn-neutral" type="button" (click)="modal.dismiss()">
      <span class="with-no-icon">{{ 'CA::Back' | abpLocalization }}</span>
    </button>
    <button class="btn ca-btn ca-btn-primary" type="button" (click)="modal.dismiss('save')">
      <i class="fa-regular fa-circle-check"></i>
      <span>{{ 'AbpUi::CompleteSelection' | abpLocalization }}</span>
    </button>
  </div>
</ng-template>
